<template>
    <v-flex xs4 ma-1>
        <v-card>

            <v-card-title>
                <v-icon>receipt</v-icon> Receipts & Refund Reports
            </v-card-title>

            <v-card-text>
               
                <v-layout column>
                    <v-btn block disabled>Receipts Batch Report</v-btn>
                    <v-btn block disabled>Refunds & Adjustments Report</v-btn>
                </v-layout>
                
            </v-card-text>

        </v-card>
    </v-flex>
</template>

<script>
    /**
     * Display buttons linking through to accounts reports
     */
    export default {
        props:[],

        data: function() {
            return {
            }
        },

        /**
         * Perform the following actions on startup
         */
        mounted: function(){},

        methods: {},

        computed: {}
    }
</script>
